// extracted by mini-css-extract-plugin
module.exports = {"decrease":"decrease-1wQoY","increase":"increase-2W4Tf","counter":"counter-1SnuJ","counter_disabled":"counter_disabled-2fr8f"};